import './Profile.scss';
import {DriverTrophyModel} from "../../features/profile/profileTypes";

type Props = {
    trophies: DriverTrophyModel[]
};

const Trophies = ({trophies}: Props) => {
    return (
        <>
            {trophies.map((trophy) => (
                <i className={`trophy-icon ${trophy.name}`} data-bs-toggle="tooltip" data-bs-placement="top" title={trophy.description}></i>
            ))}
        </>
    )
}

export default Trophies;
